module.exports = __webpack_public_path__ + "static/media/unicommerce-removebg-preview.d4f8b140.png";